var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIcCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "220D3B24-CC3B-40FE-8E99-6026FB4EAEA0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Language",
    transform: "translate(-824.000000, -268.000000)",
    stroke: "#1080FF",
    strokeWidth: 2.52808989
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-44",
    transform: "translate(495.000000, 201.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9-Copy-8",
    transform: "translate(16.000000, 53.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/-ic_check",
    transform: "translate(313.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    points: "2 8 6.0011236 12 14 4"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIcCheck);
export default __webpack_public_path__ + "static/media/icon-ic-check.71d400bf99bcf64c985e0faa6e0e1561.svg";
export { ForwardRef as ReactComponent };